'use client';

import { cn } from '@ctct/summit-core';

import {
  usePhysicalAddressForm,
  type UsePhysicalAddressFormOptions,
} from '../../../hooks/usePhysicalAddressForm';
import { PhysicalAddressFields, type PhysicalAddressFieldsProps } from './PhysicalAddressFields';

interface PhysicalAddressFormProps
  extends
    Pick<
      PhysicalAddressFieldsProps,
      | 'labels'
      | 'validationMessages'
      | 'placeholders'
      | 'fieldClassNames'
      | 'hasOrganizationName'
      | 'hasAddressLine2'
      | 'isDisabled'
      | 'isRequired'
      | 'isOrganizationNameRequired'
    >,
    UsePhysicalAddressFormOptions {
  className?: string;
  shouldPortalToForm?: boolean;
}

const PhysicalAddressForm = ({
  labels,
  validationMessages,
  placeholders,
  formKeyPrefix,
  fieldClassNames,
  hasOrganizationName = false,
  hasAddressLine2 = true,
  mode = 'all-fields',
  collapsedFieldOrder,
  expandedFieldOrder,
  isAddressLookupEnabled = true,
  shouldUseCombobox = false,
  isDefaultExpanded = false,
  isDisabled = false,
  isRequired = true,
  isOrganizationNameRequired,
  onEnterManually,
  className,
  shouldPortalToForm = true,
}: PhysicalAddressFormProps) => {
  const {
    addressAutocompleteProps,
    comboboxState,
    dropdownContainer,
    dropdownContainerRef,
    fieldOrder,
  } = usePhysicalAddressForm({
    mode,
    collapsedFieldOrder,
    expandedFieldOrder,
    formKeyPrefix,
    hasOrganizationName,
    isAddressLookupEnabled,
    shouldUseCombobox,
    isDefaultExpanded,
    onEnterManually,
  });

  return (
    <div ref={shouldPortalToForm ? dropdownContainerRef : undefined} className={cn(className)}>
      <PhysicalAddressFields
        labels={labels}
        validationMessages={validationMessages}
        placeholders={placeholders}
        formKeyPrefix={formKeyPrefix}
        fieldClassNames={fieldClassNames}
        fieldOrder={fieldOrder}
        dropdownContainer={shouldPortalToForm ? dropdownContainer : undefined}
        hasOrganizationName={hasOrganizationName}
        hasAddressLine2={hasAddressLine2}
        isDisabled={isDisabled}
        isRequired={isRequired}
        isOrganizationNameRequired={isOrganizationNameRequired}
        shouldUseCombobox={shouldUseCombobox}
        comboboxState={comboboxState}
        addressAutocompleteProps={addressAutocompleteProps}
      />
    </div>
  );
};

export { PhysicalAddressForm, type PhysicalAddressFormProps };
